import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAppSelector } from '@/core/store/hooks'
import { userSelector } from '@/modules/Auth/store/AuthSelector'
import { cn } from '@bem-react/classname'

import './User.scss'

interface IUserProps {
  className?: string
  width?: number
}

const cnUser = cn('User')

export const User: FC<IUserProps> = ({ className, width }) => {
  const navigate = useNavigate()
  const user = useAppSelector(userSelector)

  const getInitials = () => {
    if (!user) return
    const fullName = user.first_name + ' ' + user.last_name
    return fullName
      .split(' ') // Разбиваем строку по пробелам
      .map(word => word[0].toUpperCase()) // Берем первую букву каждого слова и делаем заглавной
      .join('') // Объединяем их в строку
  }

  const onClick = () => {
    navigate('/c/settings')
  }

  return (
    <div className={cnUser(null, [className])} onClick={onClick}>
      {user && (
        <>
          <div className={cnUser('avatar', { empty: !user.avatar })}>
            {user.avatar ? (
              <img src={user.avatar} alt='' />
            ) : user.first_name && user.last_name ? (
              getInitials()
            ) : (
              'A'
            )}
          </div>

          {!!width && width > 768 && (
            <div className={cnUser('info')}>
              <div className={cnUser('fullname')}>{user.full_name}</div>
              <div className={cnUser('email')}>{user.email}</div>
            </div>
          )}
        </>
      )}
    </div>
  )
}
